import { routeList } from '@/router/helpers/routes'
import { validateRouteMandatoryProps } from '@/router/helpers/validations'
/* Views */
import ThirdLevelMenu from '@/views/ThirdLevelMenu'
import Nacional from '@/views/transfers/Nacional'
import International from '@/views/transfers/International'
import InternationalCorporate from '@/views/transfers/InternationalCorporate'
import InstantBAI from '@/views/transfers/InstantBAI'
import KwikTransfer from '@/views/transfers/kwik/Transfer'
import KwikAccountManagement from '@/views/transfers/kwik/AccountManagement'
import HistoryInternational from '@/views/transfers/history/International'
import HistoryNacional from '@/views/transfers/history/Nacional'
import HistoryNaHora from '@/views/transfers/history/NaHora'
import PeriodicConsult from '@/views/transfers/periodic/Consult'
import PeriodicEdit from '@/views/transfers/periodic/Edit'
import BeneficiariesConsult from '@/views/transfers/beneficiaries/Consult'
import BeneficiariesCreate from '@/views/transfers/beneficiaries/Create'
import BeneficiariesEdit from '@/views/transfers/beneficiaries/Edit'
import RequestsInternational from '@/views/transfers/requests/International'
import RequestsInternationalCorporate from '@/views/transfers/requests/InternationalCorporate'
import RequestsNacionalNaHoraReceived from '@/views/transfers/requests/nacional/NaHoraReceived'
import RequestsNacionalNaHoraSent from '@/views/transfers/requests/nacional/NaHoraSent'
import UnderDevelopment from '@/views/UnderDevelopment'

export default [{
	path: routeList.TRANSFERS_BASE_PATH,
	beforeEnter (to, from, next) {
		next(false)
	}
}, {
	path: routeList.TRANSFERS_NACIONAL_PATH,
	name: routeList.TRANSFERS_NACIONAL_NAME,
	props: true,
	component: Nacional
}, {
	path: routeList.TRANSFERS_INTERNATIONAL_PATH,
	name: routeList.TRANSFERS_INTERNATIONAL_NAME,
	props: true,
	component: International
}, {
	path: routeList.TRANSFERS_INTERNATIONAL_CORPORATE_PATH,
	name: routeList.TRANSFERS_INTERNATIONAL_CORPORATE_NAME,
	props: true,
	component: InternationalCorporate
},
{
	path: routeList.TRANSFERS_INSTANT_BAI_PATH,
	name: routeList.TRANSFERS_INSTANT_BAI_NAME,
	props: true,
	component: InstantBAI
},
/* ***********************************************
*                        KWIK                    *
*********************************************** */
{
	path: routeList.TRANSFERS_KWIK_PATH,
	name: routeList.TRANSFERS_KWIK_NAME,
	component: ThirdLevelMenu
},
{
	path: routeList.TRANSFERS_KWIK_TRANSFER_PATH,
	name: routeList.TRANSFERS_KWIK_TRANSFER_NAME,
	component: KwikTransfer
},
{
	path: routeList.TRANSFERS_KWIK_MANAGE_ACCOUNTS_PATH,
	name: routeList.TRANSFERS_KWIK_MANAGE_ACCOUNTS_NAME,
	component: KwikAccountManagement
},
/* ********************************************* */
{
	path: routeList.TRANSFERS_REQUEST_NAHORA_PATH,
	name: routeList.TRANSFERS_REQUEST_NAHORA_NAME,
	component: UnderDevelopment
},
/* ***********************************************
*                      HISTORY                   *
*********************************************** */
{
	path: routeList.TRANSFERS_HISTORY_PATH,
	name: routeList.TRANSFERS_HISTORY_NAME,
	beforeEnter (to, from, next) {
		next(false)
	}
}, {
	path: routeList.TRANSFERS_HISTORY_INTERNATIONAL_PATH,
	name: routeList.TRANSFERS_HISTORY_INTERNATIONAL_NAME,
	component: HistoryInternational
}, {
	path: routeList.TRANSFERS_HISTORY_NACIONAL_PATH,
	name: routeList.TRANSFERS_HISTORY_NACIONAL_NAME,
	component: HistoryNacional
}, {
	path: routeList.TRANSFERS_HISTORY_NAHORA_PATH,
	name: routeList.TRANSFERS_HISTORY_NAHORA_NAME,
	component: HistoryNaHora
},
/* ***********************************************
*                     PERIODIC                   *
*********************************************** */
{
	path: routeList.TRANSFERS_PERIODIC_PATH,
	name: routeList.TRANSFERS_PERIODIC_NAME,
	component: PeriodicConsult
}, {
	path: routeList.TRANSFERS_PERIODIC_EDIT_PATH,
	name: routeList.TRANSFERS_PERIODIC_EDIT_NAME,
	props: true,
	component: PeriodicEdit,
	beforeEnter (to, from, next) {
		validateRouteMandatoryProps(to, from, next, routeList.TRANSFERS_PERIODIC_NAME)
	}
},
/* ***********************************************
*                  BENEFICIARIES                 *
*********************************************** */
{
	path: routeList.TRANSFERS_BENEFICIARIES_PATH,
	name: routeList.TRANSFERS_BENEFICIARIES_NAME,
	component: BeneficiariesConsult
},
{
	path: routeList.TRANSFERS_BENEFICIARIES_CREATE_PATH,
	name: routeList.TRANSFERS_BENEFICIARIES_CREATE_NAME,
	component: BeneficiariesCreate
},
{
	path: routeList.TRANSFERS_BENEFICIARIES_EDIT_PATH,
	name: routeList.TRANSFERS_BENEFICIARIES_EDIT_NAME,
	props: true,
	component: BeneficiariesEdit,
	beforeEnter (to, from, next) {
		validateRouteMandatoryProps(to, from, next, routeList.TRANSFERS_BENEFICIARIES_NAME)
	}
},
/* ***********************************************
*                     REQUESTS                   *
*********************************************** */
{
	path: routeList.TRANSFERS_REQUESTS_PATH,
	name: routeList.TRANSFERS_REQUESTS_NAME,
	component: ThirdLevelMenu
}, {
	path: routeList.TRANSFERS_REQUESTS_INTERNATIONAL_PATH,
	name: routeList.TRANSFERS_REQUESTS_INTERNATIONAL_NAME,
	component: RequestsInternational
}, {
	path: routeList.TRANSFERS_REQUESTS_INTERNATIONAL_CORPORATE_PATH,
	name: routeList.TRANSFERS_REQUESTS_INTERNATIONAL_CORPORATE_NAME,
	component: RequestsInternationalCorporate
},
{
	path: routeList.TRANSFERS_REQUESTS_NACIONAL_PATH,
	name: routeList.TRANSFERS_REQUESTS_NACIONAL_NAME,
	beforeEnter (to, from, next) {
		next(false)
	}
}, {
	path: routeList.TRANSFERS_REQUESTS_NACIONAL_NAHORA_SENT_PATH,
	name: routeList.TRANSFERS_REQUESTS_NACIONAL_NAHORA_SENT_NAME,
	component: RequestsNacionalNaHoraReceived
}, {
	path: routeList.TRANSFERS_REQUESTS_NACIONAL_NAHORA_RECEIVED_PATH,
	name: routeList.TRANSFERS_REQUESTS_NACIONAL_NAHORA_RECEIVED_NAME,
	component: RequestsNacionalNaHoraSent
}]
